import { render, staticRenderFns } from "./RestaurantMenuCategoriesListCard.vue?vue&type=template&id=7f9dc2ce"
import script from "./RestaurantMenuCategoriesListCard.vue?vue&type=script&lang=ts"
export * from "./RestaurantMenuCategoriesListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports